/**
 * Generated by orval v6.10.1 🍺
 * Do not edit manually.
 * Platform API
 * The Platform API
 * OpenAPI spec version: 2.0
 */

/**
 * payment gateway type
 */
export type GetPaymentGatewaysResponseItemType = typeof GetPaymentGatewaysResponseItemType[keyof typeof GetPaymentGatewaysResponseItemType];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetPaymentGatewaysResponseItemType = {
  WORLDPAY: 'WORLDPAY',
  STRIPE: 'STRIPE',
} as const;
